import React from "react";

import Link from "core/Link";
import Tooltip from "core/Tooltip";
import QuestionIcon from "core/ReusableIcons/Question";

const TooltipText = () => (
    <>
        For more information, please read our <Link href="/#">guidelines.</Link>
    </>
);

const MastheadTooltip = () => (
    <Tooltip message={<TooltipText />} clickToOpen>
        <QuestionIcon size={{ height: 24, width: 24 }} />
    </Tooltip>
);

export default MastheadTooltip;
